const getSideBarWidthByType = (state) => (type): string => state[type].sideBarWidth;
const getLastAddToSetIdsByType = (state) => (type): string => state[type].lastAddToSetIds;

export default {
  getSideBarWidthByType,
  getLastAddToSetIdsByType
}
